import { useQuery } from '@tanstack/react-query';
import { dashboardAPI } from '../services/api';
import { useOrganization } from './useOrganization';
import { useAuth } from '../context/AuthContext';

export function useAnalytics() {
  const { canViewAnalytics } = useOrganization();
  const { user, organizationId } = useAuth();

  console.log('[useAnalytics] Initial state:', {
    canViewAnalytics,
    userId: user?.id,
    organizationId
  });

  const {
    data,
    isLoading,
    error
  } = useQuery({
    queryKey: ['analyticsData', organizationId],
    queryFn: async () => {
      console.log('[useAnalytics] Fetching analytics for org:', organizationId);
      const response = await dashboardAPI.getAnalytics(organizationId);
      console.log('[useAnalytics] Raw API response:', response);
      return response;
    },
    enabled: Boolean(organizationId && canViewAnalytics),
    select: (responseData) => {
      console.log('[useAnalytics] Processing response data:', responseData);

      // Unpack user-specific stats and organization-level stats.
      const userStats = responseData.userStats || {};
      const organizationStats = responseData.organizationStats || {};

      return {
        // User-level (Your Activity) metrics:
        emailVolume: userStats.totalEmails || 0,
        dailyEmails: userStats.dailyEmails || 0,
        verificationRate: userStats.successRate || 0,
        timelineData: userStats.timelineData || [],
        avgVerificationTime: userStats.avgVerificationTime || 0,
        // (Optionally, derive unique metrics from userStats if desired.)
        uniqueRecipients: userStats.totalEmails || 0,
        uniqueVerifiedUsers: userStats.verifiedEmails || 0,

        // Organization-level metrics:
        activeUsers: organizationStats.activeUsers || 0,
        orgTotalEmails: organizationStats.totalEmails || 0,
        orgVerifiedEmails: organizationStats.verifiedEmails || 0,
        orgVerificationRate: organizationStats.verificationRate || 0
      };
    },
    refetchInterval: 30000,
    staleTime: 15000,
    retry: 2
  });

  console.log('[useAnalytics] Final processed metrics:', data);

  return {
    metrics: data,
    isLoading,
    error,
    hasAnalyticsAccess: canViewAnalytics
  };
}
